import { Extension } from '@tiptap/core'

export const PreventInsertOnKeydown = Extension.create<{ keys: ('Enter' | 'Mod-Enter')[] }>({
  name: 'PreventInsertOnEnter',

  addKeyboardShortcuts() {
    return Object.fromEntries(this.options.keys.map(key => [key, () => true]))
  },
})
